import { SplitSdk } from '@splitsoftware/splitio-react';

/**
 * Creates a Split.io SDK Factory.
 */
const splitIoFactory = () =>
  SplitSdk({
    core: {
      authorizationKey: import.meta.env.SPLIT_IO_API_KEY,
      // an initial abstract value in order to facilitate lazy loading of SDK later
      // when a client is created.
      key: 'anonymous',
    },
  });

export default splitIoFactory;
